class SharedStorageInitValue {
    constructor() {
        this.initValue = {
            /* 
                USAGE NOTES:
                    - all dynamic values should initially be set to undefined, so that we know when that value has not been set yet. 
                        so in sharedStorage, undefined means the value has not been set yet, and null means set to no value.
                    - edge case: it IS ok to set "real" init values for keys that are not expected to be updated (for example, an addon name)
                        this is because this code is crap and conflates product specific global static storage with dynamic storage
            */

            // the whitelabel values are the company details shown in components
            // it is NOT optional, and needs to always be set before using components
            whitelabel: {
                name: undefined, // (string) example: "iCompaas"
                copyright_name: undefined, // (string) example: "iCompaas LLC" (DONT include "©" or the year)
                safe_name: undefined, // (string) example: "iCompaas" (Name without spaces, periods, or extended characters but not lowercased. Used in file names for example)
                logo_url: undefined, // (string) this has to be a url that returns an image binary so we can convert it to base64 in pdf reports
                customer_support_contact: {
                    email: undefined // (string) example: "customersuccess@icompaas.com"
                },
                feature_toggle: {
                    assessment_check_remediation_link: undefined, // (bool) When true, the check remediation link is shown in the components and reports. (the link can contain the icompaas domain)
                }
            },

            addon: {
                cis: {
                    display_name: "CIS Level 1 and 2 Checks",
                    desc: "CIS Benchmarks provide the baseline configurations to ensure compliance with industry-agreed cybersecurity standards. It is a framework specializes in custom configuration of Cloud IT services and products. Organizations can use the Benchmarks and frameworks to improve cybersecurity posture.",
                    image_url_procurer_code: "addon_cis", // the addon's image code to use with the imageUrlProcurer
                    route_to_gain_access: undefined, // (null or string), when null no link will be shown
                    has_access: undefined, // (bool) true when the user is allowed to access the features of the addon (e.g. the user has an active addon subscription)
                    access_feature: { // when the user has access to the addon, they can use these features
                        assessment_compliance_code_list: ["cislevel1", "cislevel2"] // list of assessment compliance codes that the user can view
                    }
                },
                hipaa: {
                    display_name: "HIPAA Readiness Checks",
                    desc: "Regulation that provides guidelines to implement multiple safeguards to protect sensitive personal identifiable information and health related documents.",
                    image_url_procurer_code: "addon_hipaa",
                    route_to_gain_access: undefined,
                    has_access: undefined,
                    access_feature: {
                        assessment_compliance_code_list: ["hipaa"]
                    }
                },
                soc2: {
                    display_name: "SOC 2 Checks",
                    desc: "Certification that ensures your service providers securely manage your data to protect the interests of your organization and the privacy of its clients. This is essential when two companies are partnering or acquisition, mostly for SaaS based products.",
                    image_url_procurer_code: "addon_soc2",
                    route_to_gain_access: undefined,
                    has_access: undefined,
                    access_feature: {
                        assessment_compliance_code_list: ["soc2"]
                    }
                },
                iso27001: {
                    display_name: "ISO 27001 Readiness Checks",
                    desc: "Certification that demonstrates your organization has invested in the people, processes, and technology including tools and systems to protect your organization's data and provides an independent, expert assessment of whether your data is sufficiently protected. This is majorly used for companies that are in Hybrid model.",
                    image_url_procurer_code: "addon_iso27001",
                    route_to_gain_access: undefined,
                    has_access: undefined,
                    access_feature: {
                        assessment_compliance_code_list: ["iso27001"]
                    }
                },
            },
            addon_universal_access_feature: { // features that would normally be included in an addon, but are availible to all users
                assessment_compliance_code_list: ["security"]                
            },

            assessment_exception_type: undefined, // (string) allowed values: "contemporary", "as_of_assessment"

            auth_is_signed_in: undefined, // (string)
            auth_primary_role: undefined, // (string)

            cac_in_focus_cloud_account_id: undefined, // (null or string)
            cac_in_focus_cloud_type: undefined, // (null or string) example "azure"
            cac_in_focus_cloud_display_name: undefined, // (string)

            cloud_assessment_complete_compliance_code_list: ["cislevel1", "cislevel2", "hipaa", "soc2", "iso27001", "security"], // all the compliances that can have assessment scans. (these are NOT addons)

            // this is for badly scoped product component state
            // for example, exception_helper_text_config is here because it is needed deep in the requests class and can't reference a normal state value
            pc_state: {
                comp_detail: {
                    exception_helper_text_config: undefined, // (null or string)
                }
            },

            route_cloud_account_setup: undefined, // (null or string), when null no link will be shown
        }
    }

    getInitValue = () => {
        return this.initValue;
    }

    setInitValue = (newInitValue) => {
        this.initValue = newInitValue;
        return this;
    }
}

export default SharedStorageInitValue;